import React from "react";
import URLs from "constants/urls";
import ConnectorBusiness from "../Reports/connectorBusiness";
import { useMaterialUIController } from "context";
export default function ConnectorWiseBusinesByDsa() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const url1 = `${URLs.connectorWiseBusinessByDsaId}`;
  const url2 = `${URLs.connectorWiseEntriesBusinessByDsaId}`;
  return (
    <ConnectorBusiness
      connectorWiseBusinesByDateRange={url1}
      connectorWiseEntriesByDateRange={url2}
      isItByDsa={true}
    />
  );
}
